export default function CompleteDentalSolutions() {
  const treatments = [
    {
      title: 'Invisalign Treatment',
      description: 'Straighten your teeth discreetly with clear aligners. Perfect for adults who want a confident smile without traditional braces.',
      icon: 'ri-contrast-2-line',
      image: 'https://public.readdy.ai/ai/img_res/b8044ff7170edc0d48f3327037fe5adb.jpg',
      link: 'https://beaulieudental.co.uk/treatments/invisalign/'
    },
    {
      title: 'Dental Implants',
      description: 'Permanent solution for missing teeth. Natural-looking, durable implants that restore your smile and confidence.',
      icon: 'ri-tooth-line',
      image: 'https://readdy.ai/api/search-image?query=dental%20implant%20model%20showing%20titanium%20post%20and%20crown%20on%20clean%20white%20medical%20background%20professional%20dental%20care%20with%20soft%20lighting%20minimalist%20aesthetic%20modern%20healthcare%20setting&width=400&height=300&seq=dentalimplant001&orientation=landscape',
      link: 'https://beaulieudental.co.uk/treatments/dental-implants/'
    },
    {
      title: 'Composite Bonding',
      description: 'Quick and affordable way to fix chips, gaps, and discoloration. Transform your smile in just one visit.',
      icon: 'ri-paint-brush-line',
      image: 'https://readdy.ai/api/search-image?query=dental%20composite%20bonding%20procedure%20showing%20tooth%20restoration%20on%20clean%20white%20medical%20background%20professional%20cosmetic%20dentistry%20with%20soft%20lighting%20minimalist%20aesthetic%20modern%20healthcare&width=400&height=300&seq=compositebond001&orientation=landscape',
      link: 'https://beaulieudental.co.uk/treatments/composite-dental-bonding/'
    },
    {
      title: 'Porcelain Veneers',
      description: 'Ultra-thin shells that create a flawless, Hollywood smile. Long-lasting and stain-resistant.',
      icon: 'ri-layout-grid-line',
      image: 'https://readdy.ai/api/search-image?query=porcelain%20dental%20veneers%20display%20showing%20thin%20ceramic%20shells%20on%20clean%20white%20medical%20background%20professional%20cosmetic%20dentistry%20with%20soft%20lighting%20minimalist%20aesthetic%20modern%20healthcare&width=400&height=300&seq=veneers001&orientation=landscape',
      link: 'https://beaulieudental.co.uk/treatments/composite-veneers/'
    },
    {
      title: 'Teeth Whitening',
      description: 'Professional whitening treatments for a brighter, more radiant smile. Safe, effective, and long-lasting results.',
      icon: 'ri-flashlight-line',
      image: 'https://readdy.ai/api/search-image?query=professional%20teeth%20whitening%20treatment%20with%20dental%20light%20on%20clean%20white%20medical%20background%20modern%20cosmetic%20dentistry%20with%20soft%20lighting%20minimalist%20aesthetic%20professional%20healthcare%20setting&width=400&height=300&seq=whitening001&orientation=landscape',
      link: 'https://beaulieudental.co.uk/treatments/teeth-whitening/'
    },
    {
      title: 'General Dentistry',
      description: 'Comprehensive dental care including check-ups, cleanings, fillings, and preventive treatments for the whole family.',
      icon: 'ri-heart-pulse-line',
      image: 'https://readdy.ai/api/search-image?query=general%20dentistry%20checkup%20with%20dental%20tools%20on%20clean%20white%20medical%20background%20professional%20dental%20care%20with%20soft%20lighting%20minimalist%20aesthetic%20modern%20healthcare%20setting&width=400&height=300&seq=generaldent001&orientation=landscape',
      link: 'https://beaulieudental.co.uk/our-treatments/'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#444c42] mb-4">
            Complete Dental Solutions
          </h2>
          <p className="text-lg text-[#7A8178] max-w-3xl mx-auto">
            Beyond anxiety care, we offer a full range of advanced dental treatments to help you achieve your perfect smile
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {treatments.map((treatment, index) => (
            <a
              key={index}
              href={treatment.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 cursor-pointer"
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  src={treatment.image}
                  alt={treatment.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 w-12 h-12 flex items-center justify-center bg-[#d0a24f] rounded-full shadow-lg">
                  <i className={`${treatment.icon} text-xl text-white`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#444c42] mb-3 group-hover:text-[#d0a24f] transition-colors">
                  {treatment.title}
                </h3>
                <p className="text-[#7A8178] text-sm leading-relaxed">
                  {treatment.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
